// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'

import Vant from 'vant';
import 'vant/lib/index.css';
import './assets/css/common.css';

import filters from '../filters' //将全部过滤器放在 filters/index.js 中便于管理
//技巧 同时 use 多个插件 被依赖的插件应放在偏后方
filters(Vue)
Vue.use(Vant);
// Vue.use(ElementUI)
Vue.config.productionTip = false

import '../htm';

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

//赋值title
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next();
})
const config = require("../WebConfig");
Vue.prototype.config = config;
Vue.prototype.apiUrl = config.PROXYROOT;
import commonApi from '../commonApi'
Vue.prototype.commonApi = commonApi;
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    created() {
        
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js